













































































































































import { Component, Watch, Mixins } from 'vue-property-decorator';
import { SettingsMixin } from '../../mixins';
import { Form, FormInput, Select, Check } from '@/pages/profile/blocks';
import { Button } from '@/pages/profile/components';
import { Info, Message } from '../settings/components';
import { ISettins, OptionsType } from './types';
import Checkbox from '@/components/form/Checkbox.vue';

@Component({
  components: {
    Checkbox,
    Check,
    Form,
    FormInput,
    Select,
    Info,
    Message,
    Button,
  },
})
export default class InterestsSettings
  extends Mixins(SettingsMixin)
  implements ISettins
{
  get profSpheresOptions() {
    const { unpublishedProfSpheres } = this.state;
    return this.mapDictionary(unpublishedProfSpheres);
  }

  get competencesOptions() {
    const { unpublishedCompetences } = this.state;
    return this.mapDictionary(unpublishedCompetences);
  }

  get professionsOptions() {
    const { unpublishedProfessions } = this.state;
    return this.mapDictionary(unpublishedProfessions);
  }

  get employmentDictionary() {
    const { employmentDataDict } = this.state;
    return [
      { text: 'Не выбрано', value: '' },
      ...this.mapDictionary(employmentDataDict),
    ];
  }

  get workScheduleDictionary() {
    const { workScheduleDataDict } = this.state;
    return [
      { text: 'Не выбрано', value: '' },
      ...this.mapDictionary(workScheduleDataDict),
    ];
  }

  get changed() {
    const { user, profile, v } = this;
    if (v.$invalid) return false;
    return JSON.stringify(user) !== JSON.stringify(this.parceProfile(profile));
  }

  @Watch('profile', { immediate: true })
  resetUser() {
    this.reset();
  }

  validations() {
    const user: any = {};
    return { user };
  }

  mapDictionary(array: Array<OptionsType>): Array<any> {
    return Array.isArray(array)
      ? array.map(({ name, id }: OptionsType) => ({
          text: name,
          value: id,
        }))
      : [];
  }

  saveProfile() {
    const { changed } = this;
    if (changed) this.submit();
  }

  parceProfile(value: any) {
    return {
      prof_spheres: value!.prof_spheres || '',
      competences: value!.competences || '',
      professions: value!.professions || '',
      desired_position: value!.desired_position || '',
      employment_id: value!.employment_id || '',
      work_schedule_id: value!.work_schedule_id || '',
      salary: value!.salary || '',
      is_ovz_adaptation: value!.is_ovz_adaptation || false,
      is_willing_travel: value!.is_willing_travel || false,
      is_willing_relocate: value!.is_willing_relocate || false,
      is_housing_needed: value!.is_housing_needed || false,
    };
  }

  reset() {
    this.v.$reset();
    this.user = this.profile ? this.parceProfile(this.profile) : {};
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/interests/InterestsSettings.vue